import { createStore, applyMiddleware, Middleware, Store } from 'redux';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import appConfig from 'constants/appConfig';
import { requestsMiddleware } from './reduxRequests';
import createRootReducer from './rootReducer';

export const history = createBrowserHistory();

export default (): Store => {
  const middlewares: Middleware[] = [thunk];

  /**
   * Start logger only on dev environment
   */
  if (appConfig.isDev || appConfig.isStaging || appConfig.isQa) {
    middlewares.push(logger);
  }

  const store = createStore(
    createRootReducer(history),
    composeWithDevTools(
      applyMiddleware(routerMiddleware(history), ...requestsMiddleware, ...middlewares)
    )
  );

  // Hot reloading
  if (module.hot != null) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./rootReducer', () => {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const createRootReducerHot = require('./rootReducer').default;
      store.replaceReducer(createRootReducerHot(history));
    });
  }

  return store;
};
